export default __webpack_public_path__ + "media/dropdown-icon-right-2.c611042e.svg";